import React, { useEffect, useState } from "react";
import { login } from "../Services/apiService";
import { useNavigate } from "react-router-dom";
import "../assets/css/Login.css";
import logo from "../assets/images/logo.png";
import { FiMail, FiLock, FiEye, FiEyeOff } from "react-icons/fi";
import { useRole } from "../Components/RoleContext";
const LoginPage = () => {
  const { setRole } = useRole();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [isMounted, setIsMounted] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setIsMounted(true);
    return () => setIsMounted(false);
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) navigate("/region-select");
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    try {
      const response = await login(email, password);
      setRole(response?.role);
      localStorage.setItem("token", response.token);
      navigate("/region-select");
    } catch (err) {
      if (isMounted) {
        setError(err.message || "Invalid email or password");
        setIsLoading(false);
      }
    }
  };

  return (
    <div className={`login-container ${isMounted ? "mounted" : ""}`}>
      <div className="card">
        <div className="form-section">
          <div className="logo-login-container">
            <img src={logo} alt="NTD NALA Logo" className="logo" />
            <h1>NTD NALA</h1>
          </div>

          <h2>
            Welcome back! <span>Please login to continue</span>
          </h2>

          <form onSubmit={handleLogin} className="login-form">
            <div className="input-group">
              <div className="input-icon">
                <FiMail className="icon" />
              </div>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email"
                required
                disabled={isLoading}
                className={error ? "error" : ""}
              />
              <label>Email</label>
            </div>

            <div className="input-group">
              <div className="input-icon">
                <FiLock className="icon" />
              </div>
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Password"
                required
                disabled={isLoading}
                className={error ? "error" : ""}
              />
              <label>Password</label>

              <button
                type="button"
                className="toggle-password-btn"
                onClick={() => setShowPassword((prev) => !prev)}
                aria-label={showPassword ? "Hide password" : "Show password"}
              >
                {showPassword ? <FiEyeOff /> : <FiEye />}
              </button>
            </div>

            {error && (
              <div className="error-message">
                <span>!</span> {error}
              </div>
            )}

            <button
              type="submit"
              className={`login-button ${isLoading ? "loading" : ""}`}
              disabled={isLoading}
            >
              {isLoading ? "Logging in..." : "Log In"}
            </button>
          </form>
        </div>

        <div className="image-section">
          <div className="decoration">
            <div className="circle circle-1"></div>
            <div className="circle circle-2"></div>
            <div className="circle circle-3"></div>
          </div>
          <div className="content">
            <h3>NTD NALA Dashboard</h3>
            <p>Access your account to manage and monitor NTD data efficiently.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;